// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__sUJhz","content":"Footer_content__pejFV","info":"Footer_info__4N-WU","socials":"Footer_socials__XBdCT"};